import { OrganizationKeyName } from "../../../model/Organization";
import { GetOrderListFilters } from "../model/GetOrderListFilters";

export const GET_ORDER_LIST_FAIL = "SHOP:GET_ORDER_LIST_FAIL";

export const getOrderListFailAction = (
  organization: OrganizationKeyName,
  filters: GetOrderListFilters
) => ({
  type: GET_ORDER_LIST_FAIL as typeof GET_ORDER_LIST_FAIL,
  organization,
  filters,
});

export type GetOrderListFailAction = ReturnType<typeof getOrderListFailAction>;
